<template>
  <div class="MedicenCata">
    <div class="main">
      <div class="main-right" ref="mainRight">
        <!-- ==================== 顶层 Tabs ==================== -->
        <el-tabs v-model="activeTab" type="border-card" class="page-tabs">
          <!-- ① 数据看板 -->
          <el-tab-pane label="数据看板" name="dashboard">
            <div class="dashboard-wrap" v-loading="dashboardLoading">
              <div class="dashboard-cards">
                <div class="stat-card stat-card-blue">
                  <div class="stat-icon"><i class="el-icon-office-building"></i></div>
                  <div class="stat-body">
                    <div class="stat-label">供应商总数</div>
                    <div class="stat-value">{{ dashboardData.supplierCount }}</div>
                  </div>
                </div>

                <div class="stat-card stat-card-orange">
                  <div class="stat-icon"><i class="el-icon-wallet"></i></div>
                  <div class="stat-body">
                    <div class="stat-label">应付金额合计</div>
                    <div class="stat-value">{{ formatCurrency(dashboardData.totalPayAmt) }}</div>
                  </div>
                </div>

                <div class="stat-card stat-card-green">
                  <div class="stat-icon"><i class="el-icon-coin"></i></div>
                  <div class="stat-body">
                    <div class="stat-label">应收金额合计</div>
                    <div class="stat-value">{{ formatCurrency(dashboardData.totalReceAmt) }}</div>
                  </div>
                </div>

                <div class="stat-card stat-card-red">
                  <div class="stat-icon"><i class="el-icon-warning-outline"></i></div>
                  <div class="stat-body">
                    <div class="stat-label">有应付的供应商</div>
                    <div class="stat-value">{{ dashboardData.hasPayCount }}</div>
                  </div>
                </div>
              </div>

              <div class="dashboard-charts">
                <div class="chart-box">
                  <div class="chart-title">
                    <i class="el-icon-s-data"></i> 供应商应付金额排行
                  </div>
                  <div ref="payRankChart" class="chart-canvas"></div>
                </div>

                <div class="chart-box">
                  <div class="chart-title">
                    <i class="el-icon-pie-chart"></i> 应付金额占比
                  </div>
                  <div ref="receivableChart" class="chart-canvas"></div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- ② 单据列表 -->
          <el-tab-pane label="单据列表" name="list">
            <!-- 查询工具条 -->
            <div class="list-toolbar">
·
              <div class="toolbar-right">
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleOpenAddDialog">
                  新增单据
                </el-button>
              </div>
            </div>

            <!-- 单据列表表格（数据源 = supplierPayableAmountPage，列定义 = mainTableRows） -->
            <div class="table">
              <el-table
                  :data="tableData3"
                  border
                  :fit="true"
                  :summary-method="getSummaries"
                  show-summary>

                <!-- 展开行：应付分摊明细 + 财务分类明细 -->
                <el-table-column type="expand">
                  <template #default="{ row }">
                    <div class="expand-content" style="padding: 10px;">
                      <!-- 应付分摊明细 -->
                      <div class="expand-block">
                        <div class="expand-title">
                          <i class="el-icon-document"></i> 应付分摊明细
                        </div>
                        <el-table
                            :data="row.paidSupplierDetails || []"
                            size="mini"
                            border
                            style="width: 100%">
                          <el-table-column type="index" label="行号" width="60" align="center"></el-table-column>
                          <el-table-column prop="paidId" label="应付单" header-align="center" align="center" min-width="120">
                            <template #default="{ row: subRow }">
                              {{ subRow.paidId ? ('应付单 #' + subRow.paidId) : '-' }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="amount" label="本次支付金额" header-align="center" align="center" min-width="140">
                            <template #default="{ row: subRow }">
                              <span style="font-weight: bold; color: #fa8c16;">
                                {{ formatCurrency(subRow.amount) }}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div v-if="!row.paidSupplierDetails || row.paidSupplierDetails.length === 0"
                             class="empty-tip">
                          暂无应付分摊明细
                        </div>
                      </div>

                      <!-- 财务分类明细 -->
                      <div class="expand-block" style="margin-top: 12px;">
                        <div class="expand-title">
                          <i class="el-icon-wallet"></i> 财务分类明细
                        </div>
                        <el-table
                            :data="row.paySupplierDetails || []"
                            size="mini"
                            border
                            style="width: 100%">
                          <el-table-column type="index" label="行号" width="60" align="center"></el-table-column>
                          <el-table-column prop="classId" label="财务分类" header-align="center" align="center" min-width="160">
                            <template #default="{ row: subRow }">
                              {{ getFinanceClassLabel(subRow.classId) }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="amount" label="金额" header-align="center" align="center" min-width="120">
                            <template #default="{ row: subRow }">
                              <span style="font-weight: bold; color: #fa8c16;">
                                {{ formatCurrency(subRow.amount) }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="remark" label="备注" header-align="center" align="center" min-width="160">
                            <template #default="{ row: subRow }">
                              {{ subRow.remark || '-' }}
                            </template>
                          </el-table-column>
                        </el-table>
                        <div v-if="!row.paySupplierDetails || row.paySupplierDetails.length === 0"
                             class="empty-tip">
                          暂无财务分类明细
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column fixed="left" label="行号" type="index" width="60"></el-table-column>

                <el-table-column
                    v-for="(col, inx) in listColumns"
                    :key="`list_${col.prop}_${inx}`"
                    :type="col.type"
                    :prop="col.prop"
                    :label="col.name"
                    :render-header="labelHead"
                    :min-width="getColumnWidth(col.name, col.prop, tableData3)"
                    header-align="center">
                  <template #default="{ row }">
                    <template v-if="col.prop === 'id'">
                      <span>#{{ row.id }}</span>
                    </template>
                    <template v-else-if="col.prop === 'amount'">
                      <span style="font-weight: bold; color: #fa8c16;">{{ formatCurrency(row.amount) }}</span>
                    </template>
                    <template v-else-if="col.prop === 'createTime'">
                      {{ formatDateTime(row.createTime) }}
                    </template>
                    <template v-else-if="col.prop === 'imagePath'">
                      <el-link
                          v-if="row.imagePath"
                          type="primary"
                          :href="row.imagePath"
                          target="_blank"
                          :underline="false">
                        <i class="el-icon-picture-outline"></i> 查看凭证
                      </el-link>
                      <span v-else>-</span>
                    </template>
                    <template v-else>
                      {{ safeGetMappedValue(col, row) }}
                    </template>
                  </template>
                </el-table-column>

<!--                <el-table-column fixed="right" label="操作" width="148" align="center">
                  <template slot-scope="scope">
                    <div class="editbox" style="text-align: center;">
                      <el-button type="primary" size="mini" @click="handleOpenPaymentHistory(scope.row)">支付记录
                      </el-button>
                    </div>
                  </template>
                </el-table-column>-->
              </el-table>

              <el-pagination
                  style="margin-top: 12px; text-align: right;"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[8, 16, 24]"
                  :page-size="pageSize"
                  :total="totalSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  background>
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- ==================== 新增单据模态框 ==================== -->
        <el-dialog
            title="新增单据"
            :visible.sync="addDocumentDialogVisible"
            :close-on-click-modal="false"
            width="92%"
            top="5vh"
            class="add-document-dialog"
            @close="handleCloseAddDocument">

          <div class="add-document-body">
            <!-- 顶部：供应商选择 + 供应商信息 -->
            <div class="main-icon"
                 style="display: flex; align-items: center; flex-wrap: wrap; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
              <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
                <i :class="iconComes"
                   style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
                <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                    CatalogueName
                  }}</span>
              </div>

              <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
                <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">供应商:</span>
                <el-select
                    v-model="addForm.supplierId"
                    placeholder="供应商查询"
                    filterable
                    size="mini"
                    @change="handleAddSupplierChange"
                    class="custom-select">
                  <el-option
                      v-for="item in supplierOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>

                <!-- 供应商信息展示区域 -->
                <div v-if="selectedSupplier"
                     style="margin-left: 20px; display: flex; align-items: center; flex-wrap: wrap; gap: 12px;">
                  <div v-for="field in supplierFields" :key="field.prop" class="info-item">
                    <span class="info-label" style="font-size: 12px; color: #909399; margin-right: 4px;">{{
                        field.name
                      }}:</span>
                    <span class="info-value" style="font-size: 12px; color: #606266; font-weight: 500;">{{
                        selectedSupplier[field.prop] || '-'
                      }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 财务科目标签页 -->
            <el-tabs type="border-card" class="inner-tabs" style="margin-top: 12px; margin-bottom: 12px;">
              <el-tab-pane>
                <span slot="label">
                  财务科目
                  <i class="el-icon-plus"
                     style="margin-left: 8px; cursor: pointer; font-weight: bold;"
                     @click.stop="handleAddRow"></i>
                </span>

                <div class="table">
                  <el-table :data="tableData2" :fit="true" border>
                    <el-table-column fixed="left" label="行号" type="index" width="60"></el-table-column>

                    <el-table-column prop="sosId" label="收支分类" align="center">
                      <template slot-scope="scope">
                        <el-cascader
                            size="mini"
                            v-model="scope.row.sosId"
                            :options="financeClassCascaderOptions"
                            :props="cascaderProps"
                            style="width: 100%"
                            clearable
                            filterable
                            @change="(value) => handleFinanceClassCascaderChange(value, scope.row, scope.$index)"
                            :show-all-levels="false"
                            :disabled="financeClassLoading">
                          <template slot-scope="{ node, data }">
                            <span :class="{ 'disabled-text': data.disabled }">{{ data.label }}</span>
                            <span v-if="data.type" style="margin-left: 8px;">
                              <el-tag
                                  :type="getFinanceClassTagType(data.type)"
                                  size="mini"
                                  effect="plain"
                                  :disable-transitions="data.disabled">
                                {{ getFinanceClassTypeText(data.type) }}
                              </el-tag>
                            </span>
                          </template>
                        </el-cascader>
                      </template>
                    </el-table-column>

                    <el-table-column prop="amount" label="金额" align="center">
                      <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.amount"
                            type="number"
                            :min="0"
                            :max="getMaxFinancialAmount(scope.row)"
                            size="mini"
                            :disabled="tableData.length <= 0"
                            :placeholder="`最大 ${formatCurrency(getMaxFinancialAmount(scope.row))}`"
                            @change="handleFinancialAmountChange(scope.row)">
                        </el-input>
                      </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDeleteRow(scope.$index)">
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>

                  <!-- 总额提示 -->
                  <div style="margin-top: 12px; padding: 8px 12px; background: #f0f9ff; border-radius: 4px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; font-size: 13px;">
                      <div>
                        <span style="color: #606266;">单据待付总额: </span>
                        <span style="font-weight: bold; color: #e6a23c;">{{
                            formatCurrency(getTotalRemainingAmount())
                          }}</span>
                      </div>
                      <div>
                        <span style="color: #606266;">财务已填金额: </span>
                        <span style="font-weight: bold; color: #67c23a;">{{
                            formatCurrency(getTotalFinancialAmount())
                          }}</span>
                      </div>
                      <div>
                        <span style="color: #606266;">剩余可填: </span>
                        <span style="font-weight: bold; color: #f56c6c;">{{
                            formatCurrency(getTotalRemainingAmount() - getTotalFinancialAmount())
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

            <!-- 支付记录标签页（用 tableRows，含可输入结算金额，保持原样） -->
            <el-tabs type="border-card" class="inner-tabs">
              <el-tab-pane label="支付记录">
                <!-- 待付金额汇总行 -->
                <div class="remaining-amount-summary"
                     style="margin-bottom: 16px; padding: 16px; background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%); border: 1px solid #91d5ff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex; align-items: center;">
                      <i class="el-icon-wallet" style="font-size: 20px; color: #1890ff; margin-right: 12px;"></i>
                      <div>
                        <div style="font-weight: bold; color: #1890ff; font-size: 16px;">待付金额</div>
                      </div>
                    </div>
                    <div style="text-align: right;">
                      <div style="font-size: 24px; font-weight: bold; color: #fa8c16;">{{
                          formatCurrency(remainingAmount)
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table">
                  <el-table
                      :data="tableData"
                      border
                      :summary-method="getSummaries"
                      show-summary>

                    <el-table-column fixed="left" label="行号" type="index" width="60"></el-table-column>

                    <el-table-column
                        v-for="(col, inx) in tableRows"
                        :key="inx"
                        :type="col.type"
                        :prop="col.prop"
                        :label="col.name"
                        :render-header="labelHead"
                        :min-width="getColumnWidth(col.name, col.prop, tableData)"
                        header-align="center">
                      <template #default="{ row }">
                        <template v-if="col.prop === 'settlementAmount'">
                          <el-input
                              v-model="row.settlementAmount"
                              type="number"
                              :min="0"
                              :max="getMaxInputAmount(row)"
                              size="mini"
                              :placeholder="`最大可输入 ${formatCurrency(getMaxInputAmount(row))}`"
                              @change="handleAmountChange(row)">
                          </el-input>
                        </template>

                        <template v-else-if="col.prop === 'state'">
                          <el-tag
                              :type="row.state === 1 ? 'warning' : row.state === 2 ? 'primary' : row.state === 3 ? 'success' : 'danger'"
                              size="small"
                              effect="light"
                              :class="'status-tag status-tag-' + row.state">
                            <i :class="row.state === 1 ? 'el-icon-time' : row.state === 2 ? 'el-icon-wallet' : row.state === 3 ? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
                            {{
                              row.state === 1 ? '待支付' : row.state === 2 ? '部分支付' : row.state === 3 ? '支付完成' : '已作废'
                            }}
                          </el-tag>
                        </template>

                        <template v-else>
                          {{ safeGetMappedValue(col, row) }}
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>

                  <!-- 分页 -->
                  <el-pagination
                      v-if="dialogTotalSize > 0"
                      style="margin-top: 12px; text-align: right;"
                      @size-change="handleDialogSizeChange"
                      @current-change="handleDialogCurrentChange"
                      :current-page="dialogPageNum"
                      :page-sizes="[8, 16, 24]"
                      :page-size="dialogPageSize"
                      :total="dialogTotalSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background>
                  </el-pagination>

                  <!-- 操作按钮 -->
                  <div style="margin-top: 16px; text-align: right;">
                    <el-button
                        type="primary"
                        icon="el-icon-document"
                        size="medium"
                        @click="handleOneClickDistribution">
                      一键分配
                    </el-button>

                    <el-button
                        type="primary"
                        icon="el-icon-document"
                        size="medium"
                        @click="handleSaveDocument">
                      保存单据
                    </el-button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="handleCloseAddDocument">取消</el-button>
          </div>
        </el-dialog>

        <!-- ==================== 支付对话框 ==================== -->
        <el-dialog
            :title="paymentWay"
            :visible.sync="paymentDialogVisible"
            :close-on-click-modal="false"
            width="40%"
            @close="handleClosePayment"
            class="custom-form-dialog">

          <el-form
              size="mini"
              :model="paymentForm"
              ref="paymentForm"
              :rules="paymentFormRules"
              label-width="110px"
              label-position="center"
              :disabled="showSupplierDialogVisible">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="凭证上传:" prop="imagePath">
                  <el-upload
                      class="upload-demo"
                      action=""
                      :http-request="customUpload"
                      :on-remove="handleRemove"
                      :file-list="fileList"
                      :limit="1"
                      accept=".jpg,.jpeg,.png,.pdf"
                      drag>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png/pdf文件</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="备注:" prop="remark">
                  <el-input
                      v-model="paymentForm.remark"
                      type="textarea" rows="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="handleAddPayment">确认支付</el-button>
            <el-button size="mini" @click="handleClosePayment">取消</el-button>
          </div>
        </el-dialog>

        <!-- ==================== 支付记录对话框 ==================== -->
        <el-dialog
            title="供应商支付记录"
            :visible.sync="paymentHistoryDialogVisible"
            :close-on-click-modal="false"
            width="90%"
            @close="handleClosePaymentHistory"
            class="custom-form-dialog">

          <div class="table">
            <el-table :data="paymentHistoryData" border>
              <el-table-column type="expand">
                <template #default="{ row }">
                  <div class="expand-content" style="padding: 10px;">
                    <el-table
                        :data="row.paySupplierDetails"
                        size="mini"
                        border
                        style="width: 100%">
                      <el-table-column
                          v-for="(col, inx) in detailRows"
                          :key="`detail_${col.prop}_${inx}`"
                          :prop="col.prop"
                          :label="col.name"
                          header-align="center"
                          align="center"
                          :min-width="getColumnWidth(col.name, col.prop, row.paySupplierDetails)">
                        <template #default="{ row }">
                          {{ safeGetMappedValue(col, row) }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <div v-if="!row.paySupplierDetails || row.paySupplierDetails.length === 0"
                         style="text-align: center; color: #999;">
                      暂无支付详情
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column fixed="left" label="行号" type="index" width="60"></el-table-column>

              <el-table-column
                  v-for="(col, inx) in tableRows2"
                  :key="`his_${col.prop}_${inx}`"
                  :type="col.type"
                  :prop="col.prop"
                  :label="col.name"
                  :render-header="labelHead"
                  :min-width="getColumnWidth(col.name, col.prop, paymentHistoryData)"
                  header-align="center"
                  align="center">
                <template #default="{ row }">
                  <template v-if="col.prop === 'imagePath'">
                    <span v-if="row.imagePath" class="text-link">查看图片</span>
                    <span v-else>-</span>
                  </template>
                  <template v-else>
                    {{ row[col.prop] || '-' }}
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="handleClosePaymentHistory">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {pinyin} from "pinyin-pro";
import {getArea, getContuntList, getDeptList} from "@/api/reservation/reservation";
import {getDoctorList} from "@/api/scheduling/scheduling";
import {getOnCredit} from "@/api/reservation/onCredit";
import dayjs from "dayjs";
import {withLoading} from "@/untils/loading";
import {getExpenseCategoryList} from "@/api/managementMenu/expenseCategory";
import {editSupplierEntity, SupplierDetails} from "@/api/supplier";
import {
  getSupplierPayableAmountRecordPage,
  getSupplierPayableAmountRecordPayMentRecord,
  supplierPayableAmountRecordManualPayments,
  supplierPayableAmountPage
} from "@/api/supplier/supplierPayableAmountRecord";
import {selectDropDownList} from "@/api/systemCatalogue/Western";
import {uploadFile} from "@/api/user";
import {
  getFinancialSummaryAccountList,
  getOneFinancialSummaryAccountById
} from "@/api/financialSummaryManagement/financialSummaryAccount";
import {getAllFinanceclass} from "@/api/clasificacionContable/clasificacionContable";

export default {
  components: {},
  data() {
    return {
      // ============ 顶层 Tab ============
      activeTab: 'dashboard',

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      defaultProps: {
        children: 'children',
        label: 'label'
      },

      windowWidth: '',
      searchValue: '',
      CatalogueName: '付款单',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',

      // ============ 数据看板 ============
      dashboardLoading: false,
      dashboardData: {
        supplierCount: 0,
        totalPayAmt: 0,
        totalReceAmt: 0,
        hasPayCount: 0,
        rankList: []
      },
      payRankChartInstance: null,
      receivableChartInstance: null,

      // ============ 单据列表查询条件（主列表） ============
      queryConditionForm: {
        name: '',
        timeFrameArr: [
          dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ],
        state: null,
        supplierId: null,
      },

      // ============ 新增单据模态框 ============
      addDocumentDialogVisible: false,
      addForm: {
        supplierId: null
      },
      dialogPageNum: 1,
      dialogPageSize: 8,
      dialogTotalSize: 0,

      supplierOptions: [],
      selectedSupplier: null,
      supplierFields: [
        {name: "供货商名称", prop: "supplierName", type: ""},
        {name: "联系人", prop: "contact", type: ""},
        {name: "联系人电话", prop: "contactPhone"},
        {name: "应付金额", prop: "payAmt"},
        {name: "应收金额", prop: "receAmt"},
        {name: "创建时间", prop: "createTime", type: ""},
        {name: "备注", prop: "remark", type: ""},
      ],

      loading: false,
      paymentDialogVisible: false,
      paymentHistoryDialogVisible: false,
      paymentHistoryData: [],
      paymentWay: '手动支付',
      showSupplierDialogVisible: false,

      pageNum: 1,
      pageSize: 8,
      totalSize: 0,

      applyobjectOptions: [{id: 0, label: '全部'}, {id: 1, label: '门诊'}, {id: 2, label: '住院'}],
      stateOption: [{id: 0, label: '禁用'}, {id: 1, label: '可用'}],
      doctorOptions: [],

      paymentFormRules: {
        amount: [{required: true, message: ' ', trigger: 'change'}],
        discountAmt: [{required: true, message: ' ', trigger: 'change'}],
        payType: [{required: true, message: ' ', trigger: 'change'}],
      },

      addressKey: null,
      addressProps: {
        lazy: true,
        value: 'areaCode',
        label: 'areaName',
        emitPath: true,
        leaf: node => node.areaLevel >= 5,
        lazyLoad: async (node, resolve) => {
          try {
            const level = node.level + 1;
            if (level > 5) {
              return resolve([]);
            }
            const params = {
              areaCode: node.level > 0 ? node.data.areaCode : undefined,
              areaLevel: level,
              condtion: ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'][level - 1]
            };
            const res = await getArea(params);
            const responseData = res?.data || [];
            if (responseData.length === 0 && level > 1) {
              this.handleCloseCascader();
            }
            const formattedData = responseData.map(item => ({
              ...item,
              value: item.areaCode,
              label: item.areaName,
              level: level,
              isLeaf: level >= 5
            }));
            resolve(formattedData);
          } catch (error) {
            console.error('加载地区数据失败:', error);
            resolve([]);
          }
        }
      },
      provinces: [],
      conerPleasett: '',

      fileList: [],
      paymentForm: {
        amount: null,
        discountAmt: null,
        payType: null,
        imagePath: null,
        remark: '',
        recordId: null,
        supplierId: null
      },

      // 支付记录表格数据（模态框内）
      tableData: [],

      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning"},
      ],

      elTree: [
        {label: '全部', path: '', title: '', icon: 'el-icon-news', children: [],},
      ],

      busTypeOptions: [
        {id: 1, label: '采购入库'},
        {id: 2, label: '采购出库'},
        {id: 3, label: '手动支付'},
        {id: 4, label: '采购冲销'},
        {id: 5, label: '期初'}
      ],
      stateOptions: [
        {id: 1, label: '待支付'},
        {id: 2, label: '部分支付'},
        {id: 3, label: '支付完成'},
        {id: 4, label: '作废'}
      ],

      // ★ 模态框支付记录表格列（保持原样，含结算金额可输入）
      tableRows: [
        {name: "采购入库订单号", prop: "docNum", type: ""},
        {name: "供货商名称", prop: "supplierName", type: ""},
        {name: "金额", prop: "amount", type: ""},
        {name: "已付金额", prop: "paidAmt", type: ""},
        {name: "待付金额", prop: "obligationAmt", type: ""},
        {name: "结算金额", prop: "settlementAmount", type: ""},
        {name: "状态", prop: "state", type: "", op: 'stateOptions'},
        {name: "业务类型", prop: "busType", op: 'busTypeOptions'},
        {name: "创建人", prop: "createName", type: ""},
        {name: "创建时间", prop: "createTime", type: ""},
        {name: "备注", prop: "remark", type: ""},
      ],

      // ★ 主列表表格列（单据列表 —— 付款记录字段）
      mainTableRows: [
        {name: "付款单号", prop: "id", type: ""},
        {name: "付款总金额", prop: "amount", type: ""},
        {name: "付款时间", prop: "createTime", type: ""},
        {name: "备注", prop: "remark", type: ""},
        {name: "凭证图片", prop: "imagePath", type: ""},
      ],

      tableRows2: [
        {name: "金额", prop: "amount", type: ""},
        {name: "创建时间", prop: "createTime", type: ""},
        {name: "图片路径", prop: "imagePath", type: ""},
        {name: "备注", prop: "remark", type: ""},
      ],

      detailRows: [
        {name: "金额", prop: "amount", type: ""},
        {name: "发票类别", prop: "cosId", type: "", op: 'cosOptions'},
        {name: "收支分类", prop: "sosId", type: "", op: 'sosOptions'},
      ],

      selectedFinanceClassId: null,
      cascaderProps: {
        value: 'id',
        label: 'label',
        children: 'children',
        checkStrictly: true,
        emitPath: false,
        expandTrigger: 'hover'
      },
      selectedFinanceClassPath: [],
      financeClassCascaderOptions: [],
      financeClassLoading: false,
      tableData2: this.generateEmptyRows(1),
      tableData3: [],           // 主列表单据数据
      cosOptions: [],
      sosOptions: [],
      supplierCurrentDialogVisible: false,

      areaOption: [{id: 1, label: '省内'}, {id: 2, label: '省外'}, {id: 3, label: '进口'}],
      expenseCategoryOptions: [],
      financialOptions: [],
    };
  },

  computed: {
    // 主列表列（用 mainTableRows，去掉结算金额列以防万一）
    listColumns() {
      return (this.mainTableRows || []).filter(col => col.prop !== 'settlementAmount');
    },

    remainingAmount() {
      if (!this.tableData || this.tableData.length === 0) return 0;
      const totalPayable = this.tableData.reduce((sum, item) => {
        return sum + (Number(item.amount) || 0);
      }, 0);
      const totalPaid = this.tableData.reduce((sum, item) => {
        return sum + (Number(item.paidAmt) || 0);
      }, 0);
      return totalPayable - totalPaid;
    },

    filteredTableData() {
      return (this.tableData || []).filter(item =>
          item && (item.docNum || item.amount)
      );
    },

    filteredTableData2() {
      return (this.tableData2 || []).filter(item =>
          item && (item.sosId || item.cosId || item.amount)
      );
    }
  },

  async mounted() {
    this.cosOptions = this.$store.getters['preload/getCostTypeOptions'] || [];
    await this.getFinancial();
    await this.getSupplierOptions();
    await this.loadFinanceClassData();
    await this.loadData();

    window.addEventListener('resize', this.handleChartResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleChartResize);
    if (this.payRankChartInstance) {
      this.payRankChartInstance.dispose();
      this.payRankChartInstance = null;
    }
    if (this.receivableChartInstance) {
      this.receivableChartInstance.dispose();
      this.receivableChartInstance = null;
    }
  },

  methods: {
    /* ==================== 主列表相关（supplierPayableAmountPage → /outpatient/supplier/payPage） ==================== */
    async loadData() {
      try {
        const res = await supplierPayableAmountPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          supplierId: this.queryConditionForm.supplierId ?? null,
          state: this.queryConditionForm.state ?? null
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData3 = res.data.content || [];
        } else {
          this.$message.error(res.message || '系统异常:请联系管理员');
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },

    handleResetQuery() {
      this.queryConditionForm.supplierId = null;
      this.queryConditionForm.state = null;
      this.pageNum = 1;
      this.loadData();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    /* ==================== 新增单据模态框 ==================== */
    handleOpenAddDialog() {
      this.resetAddDialog();
      this.addDocumentDialogVisible = true;
    },

    resetAddDialog() {
      this.addForm.supplierId = null;
      this.selectedSupplier = null;
      this.tableData = [];
      this.tableData2 = this.generateEmptyRows(1);
      this.fileList = [];
      this.paymentForm = Object.assign({}, this.$options.data.call(this).paymentForm);
      this.dialogPageNum = 1;
      this.dialogTotalSize = 0;
    },

    handleCloseAddDocument() {
      this.addDocumentDialogVisible = false;
      this.resetAddDialog();
    },

    async handleAddSupplierChange(id) {
      this.paymentForm.supplierId = id;
      this.dialogPageNum = 1;
      await this.getSupplierDetailsDetailById(id);
      await this.loadSupplierBills(id);
    },

    async getSupplierDetailsDetailById(id) {
      if (!id) {
        this.selectedSupplier = null;
        return;
      }
      try {
        const res = await SupplierDetails({id: id});
        if (res.code === 200) {
          this.selectedSupplier = res.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async loadSupplierBills(supplierId) {
      if (!supplierId) {
        this.tableData = [];
        this.dialogTotalSize = 0;
        return;
      }
      try {
        const res = await getSupplierPayableAmountRecordPage({
          pageNum: this.dialogPageNum,
          pageSize: this.dialogPageSize,
          supplierId: supplierId,
          state: null
        });
        if (res.code === 200) {
          this.dialogTotalSize = res.data.totalSize;
          this.tableData = (res.data.content || []).map(item => ({
            ...item,
            obligationAmt: (Number(item.amount) || 0) - (Number(item.paidAmt) || 0),
            settlementAmount: 0
          }));
        } else {
          this.$message.error(res.message || '系统异常:请联系管理员');
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    handleDialogSizeChange(val) {
      this.dialogPageSize = val;
      this.dialogPageNum = 1;
      this.loadSupplierBills(this.addForm.supplierId);
    },
    handleDialogCurrentChange(val) {
      this.dialogPageNum = val;
      this.loadSupplierBills(this.addForm.supplierId);
    },

    /* ==================== 财务科目 / 分配相关 ==================== */
    handleOneClickDistribution() {
      const totalFinancialAmount = this.getTotalFinancialAmount();

      if (totalFinancialAmount <= 0) {
        this.$message.warning('请先填写财务科目金额');
        return;
      }

      const bills = this.tableData.map(item => ({
        id: item.id,
        originalAmount: Number(item.amount) || 0,
        paidAmt: Number(item.paidAmt) || 0,
        remainingAmount: (Number(item.amount) || 0) - (Number(item.paidAmt) || 0)
      }));

      let remainingToAllocate = totalFinancialAmount;
      const allocatedResults = bills.map(bill => {
        if (remainingToAllocate <= 0) {
          return 0;
        }
        const allocationAmount = Math.min(bill.remainingAmount, remainingToAllocate);
        remainingToAllocate -= allocationAmount;
        return allocationAmount;
      });

      if (remainingToAllocate > 0) {
        this.$message.warning(`财务科目金额 ${this.formatCurrency(totalFinancialAmount)} 超过所有单据待付总额 ${this.formatCurrency(this.getTotalRemainingAmount())}，剩余 ${this.formatCurrency(remainingToAllocate)} 无法分配`);
      }

      this.tableData = this.tableData.map((item, index) => ({
        ...item,
        settlementAmount: allocatedResults[index]
      }));

      this.$forceUpdate();

      const allocatedCount = allocatedResults.filter(v => v > 0).length;
      this.$message.success(`一键分配完成，已分配 ${allocatedCount} 条单据，总金额 ${this.formatCurrency(totalFinancialAmount - remainingToAllocate)}`);
    },

    processFinanceClassForCascader(nodes) {
      const typeOrder = {1: 1, 2: 2, 3: 3};

      const sortedNodes = [...nodes].sort((a, b) => {
        const orderA = typeOrder[a.type] || 4;
        const orderB = typeOrder[b.type] || 4;
        if (orderA !== orderB) return orderA - orderB;
        return (a.order || 0) - (b.order || 0);
      });

      const processNode = (node) => {
        const isMainBusinessIncome = node.label === '主营业务收入';
        const isMainBusinessIncomeChild = node.parentId === 74;

        const cascaderNode = {
          id: node.id,
          label: node.label || node.name || node.text || '',
          type: node.type || 1,
          value: node.id,
          disabled: isMainBusinessIncome || isMainBusinessIncomeChild,
          children: []
        };

        if (node.children && node.children.length > 0) {
          const sortedChildren = [...node.children].sort((a, b) => {
            const orderA = typeOrder[a.type] || 4;
            const orderB = typeOrder[b.type] || 4;
            if (orderA !== orderB) return orderA - orderB;
            return (a.order || 0) - (b.order || 0);
          });
          cascaderNode.children = sortedChildren.map(child => processNode(child));
        }

        return cascaderNode;
      };

      return sortedNodes.map(node => processNode(node));
    },

    async loadFinanceClassData() {
      try {
        this.financeClassLoading = true;
        const res = await getAllFinanceclass();
        if (res && res.children) {
          const targetRoot = res.children.find(item => item.id === 100);
          if (targetRoot) {
            this.financeClassCascaderOptions = this.processFinanceClassForCascader([targetRoot]);
          } else {
            this.financeClassCascaderOptions = [];
          }
        }
      } catch (error) {
        console.error('加载财务分类失败:', error);
      } finally {
        this.financeClassLoading = false;
      }
    },

    // 根据财务分类 id 查名称（主列表展开行用）
    getFinanceClassLabel(classId) {
      if (!classId) return '-';
      const find = (nodes) => {
        for (const node of nodes || []) {
          if (node.id === classId) return node.label;
          if (node.children && node.children.length) {
            const result = find(node.children);
            if (result) return result;
          }
        }
        return null;
      };
      const label = find(this.financeClassCascaderOptions);
      return label || `分类ID:${classId}`;
    },

    getFinanceClassTagType(type) {
      switch (type) {
        case 1:
          return 'success';
        case 2:
          return 'danger';
        case 3:
          return 'primary';
        default:
          return 'info';
      }
    },

    getFinanceClassTypeText(type) {
      switch (type) {
        case 1:
          return '收入';
        case 2:
          return '支出';
        case 3:
          return '资金';
        default:
          return '未知';
      }
    },

    handleFinanceClassCascaderChange(value, row) {
      if (value !== null) {
        this.$set(row, 'sosId', value);
      } else {
        this.$set(row, 'sosId', null);
      }
    },

    async handleOpenPaymentHistory(row) {
      const res = await getSupplierPayableAmountRecordPayMentRecord({paidId: row.id ?? null});
      if (res.code === 200) {
        this.paymentHistoryData = res.data;
        this.paymentHistoryDialogVisible = true;
      } else {
        this.$message.error(res.message);
      }
    },

    getMaxFinancialAmount(row) {
      const totalRemaining = this.getTotalRemainingAmount();
      const totalFinancial = this.getTotalFinancialAmount();
      const currentRowAmount = Number(row.amount) || 0;

      const remainingAmount = totalRemaining - (totalFinancial - currentRowAmount);
      return Math.max(0, remainingAmount);
    },

    handleFinancialAmountChange(row) {
      const maxAmount = this.getMaxFinancialAmount(row);
      const inputAmount = Number(row.amount) || 0;

      if (inputAmount > maxAmount) {
        this.$message.warning(`金额不能超过待付总额，最大可输入 ${this.formatCurrency(maxAmount)}`);
        row.amount = maxAmount;
      }

      if (inputAmount < 0) {
        row.amount = 0;
      }

      this.$forceUpdate();
    },

    getTotalRemainingAmount() {
      if (!this.tableData || this.tableData.length === 0) return 0;
      return this.tableData.reduce((sum, item) => {
        const amount = Number(item.amount) || 0;
        const paidAmt = Number(item.paidAmt) || 0;
        return sum + (amount - paidAmt);
      }, 0);
    },

    getTotalFinancialAmount() {
      if (!this.tableData2 || this.tableData2.length === 0) return 0;
      return this.tableData2.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
    },

    getMaxInputAmount(row) {
      const financialTotal = this.getFinancialTotalAmount();
      const currentTotal = this.getTotalSettlementAmount();
      const currentRowAmount = Number(row.settlementAmount) || 0;

      const remainingFinancial = financialTotal - (currentTotal - currentRowAmount);
      const billRemaining = (Number(row.amount) || 0) - (Number(row.paidAmt) || 0);

      return Math.max(0, Math.min(remainingFinancial, billRemaining));
    },

    handleAmountChange(row) {
      const maxAmount = this.getMaxInputAmount(row);
      const inputAmount = Number(row.settlementAmount) || 0;

      if (inputAmount > maxAmount) {
        this.$message.warning(`金额不能超过 ${this.formatCurrency(maxAmount)}`);
        row.settlementAmount = maxAmount;
      }

      if (inputAmount < 0) {
        row.settlementAmount = 0;
      }

      this.$forceUpdate();
    },

    getTotalSettlementAmount() {
      return this.tableData.reduce((sum, row) => {
        return sum + (Number(row.settlementAmount) || 0);
      }, 0);
    },

    getSosLabel(sosId) {
      const item = this.sosOptions.find(option => option.id === sosId);
      return item ? item.label : '-';
    },

    getCosLabel(cosId) {
      const item = this.cosOptions.find(option => option.id === cosId);
      return item ? item.label : '-';
    },

    getAmountColor(item) {
      if (this.getSosLabel(item.sosId).includes('优惠') || this.getCosLabel(item.cosId).includes('优惠')) {
        return '#67c23a';
      }
      return '#e6a23c';
    },

    getOriginalTotalAmount() {
      if (!this.filteredTableData || this.filteredTableData.length === 0) return 0;
      return this.filteredTableData.reduce((sum, item) => {
        const amount = Number(item.amount) || 0;
        const paidAmt = Number(item.paidAmt) || 0;
        return sum + (amount - paidAmt);
      }, 0);
    },

    getFinancialTotalAmount() {
      if (!this.filteredTableData2 || this.filteredTableData2.length === 0) return 0;
      return this.filteredTableData2.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
    },

    getActualPaymentAmount() {
      return this.getOriginalTotalAmount() - this.getFinancialTotalAmount();
    },

    getDiscountAmount() {
      if (!this.tableData2 || this.tableData2.length === 0) return 0;
      return this.tableData2
          .filter(item => this.getSosLabel(item.sosId).includes('优惠') || this.getCosLabel(item.cosId).includes('优惠'))
          .reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
    },

    handleSaveDocument() {
      const hasCompleteData = this.tableData2.some(row =>
          row.sosId && row.amount !== null && row.amount !== '' && !isNaN(Number(row.amount))
      );

      if (!hasCompleteData) {
        this.$message.warning('请至少填写一行完整的财务科目信息');
        return;
      }

      const totalSettlement = this.getTotalSettlementAmount();
      if (totalSettlement <= 0) {
        this.$message.warning('请先分配结算金额（可点击"一键分配"）');
        return;
      }

      this.paymentDialogVisible = true;
    },

    checkTableData2Integrity() {
      if (!this.tableData2 || this.tableData2.length === 0) {
        return {isValid: false, invalidRows: []};
      }

      const invalidRows = [];

      this.tableData2.forEach((row, index) => {
        const hasSosId = !!row.sosId;
        const hasCosId = !!row.cosId;
        const hasAmount = !!(row.amount !== null && row.amount !== '' && !isNaN(Number(row.amount)));

        const isPartial = (hasSosId || hasCosId || hasAmount) && !(hasSosId && hasCosId && hasAmount);

        if (isPartial) {
          const missingFields = [];
          if (!hasSosId) missingFields.push('收支分类');
          if (!hasCosId) missingFields.push('发票类别');
          if (!hasAmount) missingFields.push('金额');

          invalidRows.push({
            rowIndex: index,
            missingFields: missingFields
          });
        }
      });

      return {
        isValid: invalidRows.length === 0,
        invalidRows: invalidRows
      };
    },

    generateEmptyRows(count) {
      return Array.from({length: count}, () => ({
        sosId: null,
        cosId: null,
        amount: null
      }));
    },

    isRowComplete(row) {
      return row.sosId && row.cosId && row.amount !== null && row.amount !== '';
    },

    areAllRowsComplete() {
      return this.tableData2.every(row => this.isRowComplete(row));
    },

    handleCosChange() {
      this.checkAndAddRow();
    },

    checkAndAddRow() {
      this.$nextTick(() => {
        if (this.areAllRowsComplete()) {
          this.tableData2.push({
            sosId: null,
            cosId: null,
            amount: null
          });
        }
      });
    },

    handleAddRow() {
      this.tableData2.push({
        sosId: null,
        cosId: null,
        amount: null
      });
    },

    handleDeleteRow(index) {
      if (this.tableData2.length > 1) {
        this.tableData2.splice(index, 1);
      } else {
        this.tableData2[0] = {sosId: null, cosId: null, amount: null};
      }
    },

    async getFinancial() {
      const res = await getFinancialSummaryAccountList();
      this.sosOptions = res.data.map(item => {
        return {
          id: item.id, label: item.name, code: item.code
        };
      });
    },

    async handleSosChange(row) {
      const res = await getOneFinancialSummaryAccountById(row.sosId);
      if (res.code === 200) {
        if (res.data.costtypeList.length < 1) {
          this.cosOptions = [];
          return;
        }
        this.cosOptions = res.data.costtypeList.map(item => {
          return {
            id: item.id,
            label: item.name,
            applyobject: item.applyobject
          };
        });
      } else {
        this.$message.error(res.message);
      }
    },

    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        const values = data.map(item => Number(item[column.property]));

        if (!values.every(value => isNaN(value))) {
          if (column.property === 'amount') {
            const total = data.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
            sums[index] = this.formatCurrency(total);
          } else if (column.property === 'paidAmt') {
            const total = data.reduce((sum, item) => sum + (Number(item.paidAmt) || 0), 0);
            sums[index] = this.formatCurrency(total);
          } else if (column.property === 'obligationAmt') {
            const total = data.reduce((sum, item) => sum + (Number(item.obligationAmt) || 0), 0);
            sums[index] = this.formatCurrency(total);
          } else if (column.property === 'settlementAmount') {
            const total = data.reduce((sum, item) => sum + (Number(item.settlementAmount) || 0), 0);
            sums[index] = this.formatCurrency(total);
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    formatCurrency(value) {
      if (isNaN(value)) return '0.00';
      return Number(value).toFixed(2);
    },

    formatDateTime(value) {
      if (!value) return '-';
      const d = dayjs(value);
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : value;
    },

    async customUpload(options) {
      const formData = new FormData();
      formData.append('file', options.file);

      try {
        const response = await uploadFile(formData);
        if (response.code === 200) {
          this.paymentForm.imagePath = response.data.host + response.data.path;
          this.$message.success('文件上传成功');
        } else {
          this.$message.error(response.message);
        }
      } catch (error) {
        this.$message.error('文件上传失败');
      }
    },

    handleRemove() {
      this.paymentForm.imagePath = '';
      this.$message.info('文件已移除');
    },

    /* ==================== 供应商下拉 + 数据看板 ==================== */
    async getSupplierOptions() {
      try {
        this.dashboardLoading = true;
        const res = await selectDropDownList();
        if (res.code === 200) {
          const list = res.data.content || [];

          this.supplierOptions = list.map(item => ({
            id: item.id,
            label: item.supplierName
          }));

          let totalPayAmt = 0;
          let totalReceAmt = 0;
          let hasPayCount = 0;

          list.forEach(item => {
            const pay = Number(item.payAmt) || 0;
            const rece = Number(item.receAmt) || 0;
            totalPayAmt += pay;
            totalReceAmt += rece;
            if (pay > 0) hasPayCount++;
          });

          const rankList = list
              .filter(item => (Number(item.payAmt) || 0) > 0)
              .sort((a, b) => (Number(b.payAmt) || 0) - (Number(a.payAmt) || 0))
              .map(item => ({
                supplierName: item.supplierName,
                contact: item.contact,
                contactPhone: item.contactPhone,
                payAmt: Number(item.payAmt) || 0,
                receAmt: Number(item.receAmt) || 0
              }));

          this.dashboardData = {
            supplierCount: list.length,
            totalPayAmt,
            totalReceAmt,
            hasPayCount,
            rankList
          };

          this.$nextTick(() => {
            this.renderPayRankChart();
            this.renderReceivableChart();
          });
        }
      } catch (e) {
        console.error('加载供应商看板数据失败:', e);
      } finally {
        this.dashboardLoading = false;
      }
    },

    /* ==================== ECharts 渲染 ==================== */
    renderPayRankChart() {
      const chartDom = this.$refs.payRankChart;
      if (!chartDom) return;

      if (!this.payRankChartInstance) {
        this.payRankChartInstance = echarts.init(chartDom);
      }

      const top10 = this.dashboardData.rankList.slice(0, 10).reverse();
      const names = top10.map(item => item.supplierName);
      const values = top10.map(item => item.payAmt);

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {type: 'shadow'},
          formatter: (params) => {
            const p = params[0];
            return `${p.name}<br/>应付金额：<b style="color:#fa8c16">¥${Number(p.value).toFixed(2)}</b>`;
          }
        },
        grid: {
          left: 10,
          right: 60,
          top: 10,
          bottom: 10,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: (val) => {
              if (val >= 10000) return (val / 10000).toFixed(1) + '万';
              return val;
            }
          },
          splitLine: {lineStyle: {type: 'dashed', color: '#ebeef5'}}
        },
        yAxis: {
          type: 'category',
          data: names,
          axisLabel: {
            fontSize: 12,
            color: '#606266',
            formatter: (val) => val.length > 8 ? val.substring(0, 8) + '...' : val
          },
          axisTick: {show: false},
          axisLine: {lineStyle: {color: '#dcdfe6'}}
        },
        series: [
          {
            name: '应付金额',
            type: 'bar',
            data: values,
            barWidth: 16,
            itemStyle: {
              borderRadius: [0, 8, 8, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {offset: 0, color: '#ffb74d'},
                {offset: 1, color: '#fa8c16'}
              ])
            },
            label: {
              show: true,
              position: 'right',
              fontSize: 12,
              color: '#fa8c16',
              fontWeight: 'bold',
              formatter: (params) => Number(params.value).toFixed(2)
            }
          }
        ]
      };

      this.payRankChartInstance.setOption(option, true);
    },

    renderReceivableChart() {
      const chartDom = this.$refs.receivableChart;
      if (!chartDom) return;

      if (!this.receivableChartInstance) {
        this.receivableChartInstance = echarts.init(chartDom);
      }

      const top10 = this.dashboardData.rankList.slice(0, 10);
      const pieData = top10.map(item => ({
        name: item.supplierName,
        value: item.payAmt
      }));

      const topSum = top10.reduce((s, i) => s + i.payAmt, 0);
      const otherSum = this.dashboardData.totalPayAmt - topSum;
      if (otherSum > 0.01) {
        pieData.push({name: '其他供应商', value: Number(otherSum.toFixed(2))});
      }

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const percent = params.percent;
            return `${params.name}<br/>应付金额：<b style="color:#fa8c16">¥${Number(params.value).toFixed(2)}</b><br/>占比：${percent}%`;
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 'middle',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {fontSize: 12, color: '#606266'},
          formatter: (name) => name.length > 10 ? name.substring(0, 10) + '...' : name
        },
        color: [
          '#5b8ff9', '#5ad8a6', '#5d7092', '#f6bd16', '#e8684a',
          '#6dc8ec', '#9270ca', '#ff9d4d', '#269a99', '#ff99c3', '#c0c4cc'
        ],
        series: [
          {
            name: '应付金额占比',
            type: 'pie',
            radius: ['42%', '68%'],
            center: ['38%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
                formatter: '{b}\n{d}%'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            },
            labelLine: {
              show: false
            },
            data: pieData
          }
        ]
      };

      this.receivableChartInstance.setOption(option, true);
    },

    handleChartResize() {
      if (this.payRankChartInstance) {
        this.payRankChartInstance.resize();
      }
      if (this.receivableChartInstance) {
        this.receivableChartInstance.resize();
      }
    },

    /* ==================== 其它 ==================== */
    getRowClassName({row}) {
      if (row.docNum) {
        const sameDocNumRows = this.tableData.filter(item => item.docNum === row.docNum);
        if (sameDocNumRows.length > 1) {
          const docNumHash = this.hashString(row.docNum);
          return `docnum-group-color-${docNumHash % 6}`;
        }
      }
      return '';
    },

    hashString(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    },

    validatePhone() {
      const phoneReg = /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/;
      if (!phoneReg.test(this.paymentForm.contactPhone)) {
        this.$message.error('请输入正确的手机号或座机号（座机格式：区号-号码）');
        return false;
      }
      return true;
    },

    async loadSelectedPath(type = 'coner') {
      try {
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }

        const codeKey = `${type}AddCodeArr`;
        const codes = this.paymentForm[codeKey] || [];
        const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'];
        let currentNodes = this.provinces;
        const loadedCodes = [];

        for (let i = 0; i < codes.length; i++) {
          const code = codes[i];
          const level = i + 1;

          let targetNode = currentNodes.find(node => node.areaCode === code);

          if (!targetNode) {
            const parentCode = i > 0 ? codes[i - 1] : undefined;
            const params = {
              areaCode: parentCode,
              areaLevel: level,
              condtion: levelConditions[i]
            };
            const res = await getArea(params);
            currentNodes = res.data || [];
            targetNode = currentNodes.find(node => node.areaCode === code);

            if (level === 1) {
              this.provinces = currentNodes;
            }
          }

          if (!targetNode) {
            break;
          }

          loadedCodes.push(code);

          if (level < 5 && (!targetNode.children || targetNode.children.length === 0)) {
            const nextLevelParams = {
              areaCode: code,
              areaLevel: level + 1,
              condtion: levelConditions[level]
            };
            const res = await getArea(nextLevelParams);
            targetNode.children = res.data || [];

            if (level === 5) {
              targetNode.children.forEach(item => {
                item.isLeaf = true;
              });
            }
          }

          currentNodes = targetNode.children || [];
        }

        this.$nextTick(() => {
          this.paymentForm[codeKey] = [];
          setTimeout(() => {
            this.paymentForm[codeKey] = [...loadedCodes];
          }, 200);
        });

      } catch (error) {
        console.error(`加载${type}地址路径失败:`, error);
        this.$message.error(`${type === 'coner' ? '联系' : '籍贯'}地址加载失败，请重试`);
      }
    },

    async initAddressData() {
      try {
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }
        if (this.paymentForm.conerAddCodeArr.length > 0) {
          await this.loadSelectedPath('coner');
        }
      } catch (error) {
        console.error('地址初始化失败:', error);
      }
    },

    checkCodeExist() {
      if (!this.paymentForm.code) return;

      this.codeExist = this.financialOptions.some(
          item => item.code === this.paymentForm.code
      );

      if (this.codeExist) {
        this.$message.error('该编码已被使用，请重新输入');
        return false;
      }
      return true;
    },

    handleRemoveChange(item) {
      if (item.length <= 0) return;
      this.expenseCategoryOptions.push(item[item.length - 1]);
    },

    handleRemoveTage(tag) {
      this.$set(this.expenseCategoryOptions, this.expenseCategoryOptions.filter(item => item.id === tag));
    },

    async getExpenseCategoryList(query) {
      const res = await getExpenseCategoryList({name: query});
      if (res.code === 200) {
        this.expenseCategoryOptions = res.data.map(item => {
          return {id: item.id, applyobject: item.applyobject, label: item.name};
        });
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },

    async handleConditionQuery() {
      try {
        const res = await getOnCredit({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',
          startTime: this.queryConditionForm.timeFrameArr?.[0] || '',
          endTime: this.queryConditionForm.timeFrameArr?.[1] || '',
          state: this.state ?? null
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            return {
              ...item,
              createTime: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
              endTime: item.endTime ? dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
              beginTime: item.beginTime ? dayjs(item.beginTime).format('YYYY-MM-DD HH:mm:ss') : ''
            };
          });
          await this.getContuntList();
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    async handleEditSupplier(row) {
      this.paymentForm = {...row};
      this.paymentDialogVisible = true;
    },

    async handleAddPayment() {
      await withLoading(this, '数据提交中...')(async () => {
        const requestData = {
          imagePath: this.paymentForm.imagePath || '',
          paySupplierDetailVOS: this.tableData2.map(row => ({
            amount: Number(row.amount) || 0,
            classId: Number(row.sosId) || 0
          })),
          supplierDetali: this.tableData
              .filter(item => item.id && Number(item.settlementAmount) > 0)
              .map(item => ({
                amount: Number(item.settlementAmount) || 0,
                id: Number(item.id) || 0
              })),
          remark: this.paymentForm.remark || '',
          supplierId: this.addForm.supplierId || 0
        };

        const res = await supplierPayableAmountRecordManualPayments(requestData);
        if (res.code === 200) {
          this.fileList = [];
          this.handleClosePayment();
          this.addDocumentDialogVisible = false;
          this.resetAddDialog();
          this.pageNum = 1;
          await this.loadData();
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    async getContuntList() {
      if (this.contractUnitOption && this.contractUnitOption.length > 0) return;
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => {
        return {id: item.id, label: item.name};
      });
    },

    handleClosePayment() {
      this.paymentForm = Object.assign({}, this.$options.data.call(this).paymentForm);
      this.$nextTick(() => {
        if (this.$refs.paymentForm) {
          this.$refs.paymentForm.clearValidate();
        }
      });
      this.fileList = [];
      this.paymentDialogVisible = false;
      this.showSupplierDialogVisible = false;
    },

    handleClosePaymentHistory() {
      this.paymentHistoryDialogVisible = false;
    },

    handleExpenseCateGoryForGetPy() {
      if (!this.paymentForm.name) return;

      this.nameExist = this.financialOptions.some(
          item => item.label === this.paymentForm.name
      );

      if (this.nameExist) {
        this.$message.error('该名称已被使用，请重新输入');
        this.paymentForm.pycode = '';
        return false;
      }
      this.paymentForm.pycode =
          pinyin(this.paymentForm.name, {
            pattern: 'first',
            toneType: 'none',
            separator: ''
          }).toLocaleUpperCase();
      return true;
    },

    async getDeptList() {
      const res = await getDeptList();
      this.deptOptions = res.data.map(item => {
        return {id: item.id, label: item.deptName};
      });
    },

    async getDoctorList() {
      const res = await getDoctorList();
      this.doctorOptions = res.data.map(item => {
        return {id: item.id, label: item.fullName};
      });
    },

    async handleStartOrDisabled(row) {
      try {
        const confirmMessage = row.state === 1 ? `确定要禁用${row.supplierName}吗？` : `确定要启用${row.supplierName}吗？`;
        const confirmResult = await this.$confirm(confirmMessage, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => {
          return false;
        });

        if (!confirmResult) return;

        this.paymentForm = {...row};
        this.paymentForm.status = row.status === 1 ? 0 : 1;
        const res = await editSupplierEntity(this.paymentForm);
        if (res.code === 200) {
          await this.loadData();
          this.$message.success(`修改${this.paymentForm.supplierName}状态成功`);
        } else {
          this.$message.error(`修改${this.paymentForm.supplierName}状态失败`);
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作过程中发生错误');
      }
    },

    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      const matched = mapArray.find(item => item.id === rawValue);
      return matched?.label || rawValue;
    },

    handleNodeClick() {
      this.searchValue = '';
      this.loadData();
    },

    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 40;
      let maxlenStr = "";
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      return width + 12;

      function len(str) {
        let length = 8;
        for (const char of str + "") {
          if ("a" <= char && char <= "z") length += 8;
          else if ("A" <= char && char <= "Z") length += 8;
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
          else length += 12;
        }
        return length;
      }
    },

    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 328;
    },

    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 20;
      const contentList = (tableData || []).map(item => item?.[prop] ?? '');

      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5);
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
  }
};
</script>

<style lang="less" scoped>
/* ==================== 顶层 Tab ==================== */
.page-tabs {
  border: none !important;
  box-shadow: none !important;
}

/* ==================== 数据看板 ==================== */
.dashboard-wrap {
  padding: 16px;
  min-height: 420px;
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

@media (max-width: 1100px) {
  .dashboard-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-right: 14px;
    flex-shrink: 0;
  }

  .stat-body {
    flex: 1;
    min-width: 0;
  }

  .stat-label {
    font-size: 13px;
    opacity: 0.9;
    margin-bottom: 6px;
  }

  .stat-value {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.2;
    word-break: break-all;
  }
}

.stat-card-blue {
  background: linear-gradient(135deg, #4facfe 0%, #00c6ff 100%);
}

.stat-card-orange {
  background: linear-gradient(135deg, #fa8c16 0%, #ffb74d 100%);
}

.stat-card-green {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stat-card-red {
  background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
}

/* ==================== 图表容器 ==================== */
.dashboard-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 1200px) {
  .dashboard-charts {
    grid-template-columns: 1fr;
  }
}

.chart-box {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.chart-canvas {
  width: 100%;
  height: 380px;
}

/* ==================== 单据列表工具条 ==================== */
.list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.toolbar-label {
  font-size: 12px;
  color: #606266;
  font-weight: bold;
  margin-right: 6px;
}

/* ==================== 通用表格样式 ==================== */
::v-deep .el-table .cell {
  font-size: 12px;
  text-align: center;
}

::v-deep .el-table td.el-table__cell div {
  text-align: center;
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
}

/* ==================== 供应商信息 ==================== */
.supplier-info {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px 12px;
}

.info-item {
  display: inline-flex;
  align-items: center;
}

.info-label {
  font-size: 12px;
  color: #909399;
}

.info-value {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

@media (max-width: 1200px) {
  .supplier-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

/* ==================== 新增单据模态框 ==================== */
.add-document-dialog {
  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
  }

  ::v-deep .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
  }
}

.add-document-body {
  min-height: 200px;
}

.inner-tabs {
  ::v-deep .el-tabs__item {
    padding: 0 10px !important;
    height: 32px !important;
    line-height: 32px !important;
    font-size: 12px;
  }
}

/* ==================== 展开行样式 ==================== */
.expand-block {
  .expand-title {
    font-size: 12px;
    font-weight: bold;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;
    margin-bottom: 8px;
  }
}

.empty-tip {
  text-align: center;
  color: #999;
  font-size: 12px;
  padding: 8px 0;
}

/* ==================== docNum 分组颜色 ==================== */
::v-deep .el-table .docnum-group-color-0 td {
  background-color: #e6f7ff !important;
}

::v-deep .el-table .docnum-group-color-1 td {
  background-color: #f6ffed !important;
}

::v-deep .el-table .docnum-group-color-2 td {
  background-color: #fff7e6 !important;
}

::v-deep .el-table .docnum-group-color-3 td {
  background-color: #fff2f0 !important;
}

::v-deep .el-table .docnum-group-color-4 td {
  background-color: #f9f0ff !important;
}

::v-deep .el-table .docnum-group-color-5 td {
  background-color: #e6fffb !important;
}

::v-deep .el-table .docnum-group-color-0:hover td {
  background-color: #d4f0ff !important;
}

::v-deep .el-table .docnum-group-color-1:hover td {
  background-color: #ebffd4 !important;
}

::v-deep .el-table .docnum-group-color-2:hover td {
  background-color: #ffefd4 !important;
}

::v-deep .el-table .docnum-group-color-3:hover td {
  background-color: #ffe8e4 !important;
}

::v-deep .el-table .docnum-group-color-4:hover td {
  background-color: #f2e6ff !important;
}

::v-deep .el-table .docnum-group-color-5:hover td {
  background-color: #d4fff8 !important;
}

/* ==================== 弹窗样式穿透 ==================== */
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-pagination {
  padding: 6px;
}

/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/* ==================== 主体容器 ==================== */
.MedicenCata {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;

        .main-icon-b {
          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }
        }
      }
    }
  }
}
</style>